"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const scrollspy_1 = require("./scrollspy");
const scrollSpy = (el, options = {}) => {
    const instance = new scrollspy_1.ScrollSpy(el, options);
    instance.onScroll();
    window.addEventListener('scroll', () => instance.onScroll());
    return instance;
};
exports.default = scrollSpy;
//# sourceMappingURL=index.js.map